import AsyncStorage from "@react-native-async-storage/async-storage";
import { useNavigation } from "@react-navigation/native";
import { createContext, useContext, useState } from "react";
import { api } from "../api/api";
import UserContext from "./user";

interface RouteContextData {
    newRoute: any;
    setNewRoute: any;
    pendingOrders: any;
    completeOrders: any;
    allOrders: any;
    individualOrder: any;
    setPendingOrders: any;
    setCompleteOrders: any;
    setAllOrders: any;
    setIndividualOrder: any;
    finalizeDelivery: any;
    setFinalizeDelivery: any;
    loading: boolean;
    registerRoute(orders: dataProps): Promise<void>;
    getRoute(): Promise<void>;
    getRouteDriver(): Promise<void>;
    getIndividualOrder(id: number): Promise<void>;
    reportProblem(id: number): Promise<void>;
    cancelRoute(id: number, data: any): Promise<void>;
}

interface dataRoutes {
    recipient: number;
    recipientName: string;
    noteNumber: string;
  }

interface dataProps {
    driver: number
    isAdmin: boolean,
    date: string,
    routes: dataRoutes[]
}

interface dataFinalizeDeliveryProps {
  order_status: string;
  problem: string;
  image: any;
}

const data: dataProps = {
    driver: 0,
    isAdmin: true,
    date: "",
    routes: []
}

const dataFinalizeDelivery: dataFinalizeDeliveryProps = {
  order_status: '1',
  problem: '',
  image: ''
};

const RouteContext = createContext({} as RouteContextData);

export function RouteProvider({ children }) {
  const navigation = useNavigation();
  const { user } = useContext(UserContext);
  const [newRoute, setNewRoute] = useState<dataProps>(data);
  const [pendingOrders, setPendingOrders] = useState([]);
  const [completeOrders, setCompleteOrders] = useState([]);
  const [allOrders, setAllOrders] = useState([]);
  const [individualOrder, setIndividualOrder] = useState([]);
  const [finalizeDelivery, setFinalizeDelivery] = useState<dataFinalizeDeliveryProps>(dataFinalizeDelivery);
  const [loading, setLoading] = useState(false);

  async function registerRoute(orders: dataProps) {
    setLoading(true);
    const role = await AsyncStorage.getItem('@lmatransportes:role');
    console.log(orders)
    api.post('/orders', orders).then(async (response) => {
        if(role === '1') {
          setLoading(false);
          await getRoute();
          navigation.navigate("ReportAdmin");
        }
        if(role === '2') {
          setLoading(false);
          await getRouteDriver();
          navigation.navigate("DashboardDriver");
        }
        setLoading(false);
    })
    .catch((err) => {
        console.log('registerRoute', err);
        setLoading(false)
        if(err?.response?.status === 401){
          navigation.reset({
            index: 0,
            routes: [{ name: "Login" }],
          });
        }
        return err;
    })
  }

  async function getRoute() {
    api.get('/orders/all').then((response) => {
      let routes: any = [];
      let routePendingOrders: any = [];
      let routeCompleteOrders: any = [];
      response.data.pendingOrders.map((item: any) => {
        routePendingOrders.push(item);
        routes.push(item);
      });
      response.data.completeOrders.map((item: any) => {
        routeCompleteOrders.push(item);
        routes.push(item);
      });
      setPendingOrders(routePendingOrders);
      setCompleteOrders(routeCompleteOrders);
      setAllOrders(routes);
    })
    .catch((err) => {
        console.log('getRoute', err);
        if(err?.response?.status === 401){
          navigation.reset({
            index: 0,
            routes: [{ name: "Login" }],
          });
        }
        return err;
    })
  }

  async function getRouteDriver() {
    api.get('/orders').then((response) => {
      console.log('get Driver');
      let routes: any = [];
      let routePendingOrders: any = [];
      let routeCompleteOrders: any = [];
      response.data.pendingOrders.map((item: any) => {
        routePendingOrders.push(item);
        routes.push(item);
      });
      response.data.completeOrders.map((item: any) => {
        routeCompleteOrders.push(item);
        routes.push(item);
      });
      setPendingOrders(routePendingOrders);
      setCompleteOrders(routeCompleteOrders);
      setAllOrders(routes);
    })
    .catch((err) => {
        console.log('getRouteDriver', err);
        if(err?.response?.status === 401){
          navigation.reset({
            index: 0,
            routes: [{ name: "Login" }],
          });
        }
        return err;
    })
  }

  async function getIndividualOrder(id: number) {
    // Reseta o estado de finalização ao abrir uma ordem, evitando que status/problema/foto
    // de uma entrega anterior vazem para esta.
    setFinalizeDelivery(dataFinalizeDelivery);
    api.get(`/orders/${id}`).then((response) => {
      console.log('delivery => ', response.data.order);
      setIndividualOrder(response.data.order[0]);
    })
    .catch((err) => {
        console.log('registerRoute', err);
        if(err?.response?.status === 401){
          navigation.reset({
            index: 0,
            routes: [{ name: "Login" }],
          });
        }
        return err;
    })
  }

  async function reportProblem(id: number) {
    setLoading(true);
    api.put(`/orders/${id}`, finalizeDelivery).then((response) => {
      console.log('save => ', response.data, id);
      navigation.navigate('Success');
      setLoading(false);
      // Obs: o reset do estado acontece ao abrir a próxima ordem (getIndividualOrder),
      // preservando finalizeDelivery.order_status para a tela Success exibir a mensagem correta.
    })
    .catch((err) => {
        console.log('reportProblem', err);
        setLoading(false);
        if(err?.response?.status === 401){
          navigation.reset({
            index: 0,
            routes: [{ name: "Login" }],
          });
        }
        throw err;
    })
  }

  async function cancelRoute(id: number, data: any) {
    setLoading(true);
    api.put(`/orders/cancel/${id}`, data).then(async (_) => {
      setLoading(false);
      await getRoute();
    })
    .catch((err) => {
        console.log('cancelRoute', err);
        setLoading(false);
        if(err?.response?.status === 401){
          navigation.reset({
            index: 0,
            routes: [{ name: "Login" }],
          });
        }
        throw err;
    })
  }

  return (
    <RouteContext.Provider
      value={{
        newRoute,
        pendingOrders,
        allOrders,
        completeOrders,
        individualOrder,
        finalizeDelivery,
        loading,
        setNewRoute,
        registerRoute,
        getRoute,
        getIndividualOrder,
        setPendingOrders,
        setCompleteOrders,
        setAllOrders,
        setIndividualOrder,
        getRouteDriver,
        reportProblem,
        setFinalizeDelivery,
        cancelRoute
      }}
    >
      {children}
    </RouteContext.Provider>
  );
}

export default RouteContext;
